import { Button } from '../../../../../components/form/button';
import Icon from '../../../../../components/icons/icon';
import { Typography } from '../../../../../components/typography/typography';

export const TagHeader = ({
  previousUrl,
  crudActionLabel,
  isEditing,
  createProductCall,
}: {
  previousUrl: string;
  crudActionLabel: string;
  isEditing: boolean;
  createProductCall: () => void;
}) => {
  return (
    <div className="add-discount-header flex flex-col md:flex-row justify-between gap-2">
      <div className="flex gap-2">
        <a className="cursor-pointer" href={previousUrl}>
          <Icon icon="Back" size="large" />
        </a>
        <Typography type="text-xl" weight="semi-bold">
          {crudActionLabel}
        </Typography>
      </div>
      <div className="crud-actions gap-2">
        {!isEditing && (
          <Button
            className="button button-yellow md"
            data-cy="save_discount"
            onClick={() => {
              if (!isEditing) {
                createProductCall();
              }
            }}
          >
            <Icon icon="FloppySave" size="medium" stroke="var(--quipli-black-800)" />
            <Typography type="text-md" weight="semi-bold" className="text-[var(--quipli-black-800)]">
              {'Create Discount'}
            </Typography>
          </Button>
        )}
      </div>
    </div>
  );
};
